'use client';

import { useCallback } from 'react';

import { usePostGameUpsell } from '@/components/PostGameUpsellModal';
import { beforeGameOffers } from '@/utils';

import { usePromotionOffers } from './usePromotionOffers';

type UsePreGameOfferParams = {
  raffleId: string | undefined;
};

type OpenPreGameOfferParams = {
  onDismiss: () => void;
};

type UsePreGameOfferReturn = {
  isResolved: boolean;
  hasOffer: boolean;
  openPreGameOffer: (params: OpenPreGameOfferParams) => void;
};

export const usePreGameOffer = ({
  raffleId,
}: UsePreGameOfferParams): UsePreGameOfferReturn => {
  const state = usePromotionOffers({ raffleId });
  const { showPostGameUpsell } = usePostGameUpsell();

  const offer =
    state.status === 'unified' ? beforeGameOffers(state.offers)[0] : undefined;

  const isResolved = !raffleId ? true : state.status !== 'loading';

  const hasOffer =
    state.status === 'unified' &&
    state.isOnSale &&
    Boolean(state.ticketPrice) &&
    Boolean(raffleId) &&
    Boolean(offer);

  const openPreGameOffer = useCallback(
    ({ onDismiss }: OpenPreGameOfferParams) => {
      if (state.status !== 'unified') return;
      if (!state.isOnSale || !offer || !raffleId || !state.ticketPrice) return;

      showPostGameUpsell({
        raffleId,
        raffleName: state.raffleName,
        offer,
        ticketPrice: state.ticketPrice,
        gameTitle: state.raffleName,
        variant: 'pre_game',
        onDismiss,
      });
    },
    [state, offer, raffleId, showPostGameUpsell],
  );

  return { isResolved, hasOffer, openPreGameOffer };
};
